'use client';

import React from 'react';

interface HalftoneContainerProps {
  children: React.ReactNode;
  className?: string;
}

const HalftoneContainer: React.FC<HalftoneContainerProps> = ({
  children,
  className = '',
}) => {
  const containerStyles: React.CSSProperties = {
    position: 'relative',
    background: 'white',
    zIndex: 1,
  };

  return (
    <div className={className} style={containerStyles}>
      {children}
      <style jsx>{`
        div::before {
          content: '';
          position: absolute;
          inset: 0;
          background-image: radial-gradient(
            circle at 50% 50%,
            rgb(232, 234, 234) 0 0.5px,
            transparent 2px
          );
          background-size: 13px 13px;
          -webkit-mask-image: radial-gradient(
            circle at 50% 50%,
            rgba(0, 0, 0, 1),
            rgba(0, 0, 0, 0.2) 100%
          );
          mask-image: radial-gradient(
            circle at 50% 50%,
            rgba(0, 0, 0, 1),
            rgba(0, 0, 0, 0.2) 100%
          );
          z-index: -1;
        }
      `}</style>
    </div>
  );
};

export default HalftoneContainer;
